import { useNavigate } from "react-router-dom";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useBodyClass from "../_hooks/useBodyClass";
import "./Home.css";

export { Home };

function Home() {
  const navigate = useNavigate();
  useBodyClass("module-page-body");
  const { t } = useTranslation();

  return (
    <div>
      <section className="module-page-sec relative d-flex align-center justify-center">
        <div className="module-page-body relative d-flex align-center justify-center">
          <div className="module-page-list d-grid">
            <div className="module-box relative d-flex flex-col align-start">
              <div className="module-box-title relative d-flex align-center">
                <img src="images/vendor-details-icon.svg" alt="" />{" "}
                <span>{t('home.VendorDetails')}</span>
              </div>
              <div className="module-box-p relative d-flex align-center">
                {t('home.manageVendorInfo')}
              </div>
              <button type="button" className="module-box-btn relative d-flex align-center" onClick={() => navigate("/vendor")}>
                {t("Let's go")}
              </button>
            </div>
            <div className="module-box relative d-flex flex-col align-start">
              <div className="module-box-title relative d-flex align-center">
                <img src="images/product-catalogue-icon.svg" alt="" />{" "}
                <span>{t('home.productCatalogue')}</span>
              </div>
              <div className="module-box-p relative d-flex align-center">
                {t('home.manageProductInfo')}
              </div>
              <button type="button" className="module-box-btn relative d-flex align-center" onClick={() => navigate("/product-catalog")}>
                {t("Let's go")}
              </button>
            </div>
            <div className="module-box relative d-flex flex-col align-start">
              <div className="module-box-title relative d-flex align-center">
                <img src="images/purchase-order-icon.svg" alt="" />{" "}
                <span>  {t('home.purchaseOrder')}</span>
              </div>
              <div className="module-box-p relative d-flex align-center">
                {t('home.managePurchaseOrder')}{" "}
              </div>
              <button type="button" className="module-box-btn relative d-flex align-center" onClick={() => navigate("/app")}>
                {t("Let's go")}
              </button>
            </div>
            <div className="module-box relative d-flex flex-col align-start">
              <div className="module-box-title relative d-flex align-center">
                <img src="images/inventory-icon.svg" alt="" />{" "}
                <span>  {t('home.returnToVendor')}</span>
              </div>
              <div className="module-box-p relative d-flex align-center"> {t('Your Returns & their details')}</div>
              <button type="button" className="module-box-btn relative d-flex align-center" onClick={() => navigate("/rtv")}>
                {t("Let's go")}
              </button>
            </div>
            <div className="module-box relative d-flex flex-col align-start">
              <div className="module-box-title relative d-flex align-center">
                <img src="images/folder-open-icon.svg" alt="" />{" "}
                <span>  {t('Document Center')}</span>
              </div>
              <div className="module-box-p relative d-flex align-center"> {t('Get access to & share business documents')}</div>
              <button type="button" className="module-box-btn relative d-flex align-center" onClick={() => navigate("/document-center")}>
                {t("Let's go")}
              </button>
            </div>
          
          </div>
        </div>
     
      </section>
    </div>
  );
}